import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "./lib/AuthContext";
import Layout from "./components/layout/Layout";
import ScrollToTop from "./components/ScrollToTop";

import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import FAQs from "./pages/FAQs";
import Resources from "./pages/Resources";
import AccidentTypes from "./pages/AccidentTypes";
import AccidentTypeDetail from "./pages/AccidentTypeDetail";
import PennsylvaniaCities from "./pages/PennsylvaniaCities";
import PennsylvaniaCityDetail from "./pages/PennsylvaniaCityDetail";
import Blog from "./pages/Blog";
import BlogPostPage from "./pages/BlogPost";
import AuthorProfile from "./pages/AuthorProfile";
import EditorialPolicy from "./pages/EditorialPolicy";
import CorrectionsPolicy from "./pages/CorrectionsPolicy";
import NotFound from "./pages/NotFound";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import LeadsPage from "./pages/admin/LeadsPage";
import { BlogManager, CityManager, AccidentTypeManager, FAQManager, TestimonialManager } from "./pages/admin/managers";
import ContentStrategy from "./pages/admin/ContentStrategy";
import Calendar from "./pages/admin/Calendar";
import Exports from "./pages/admin/Exports";
import SeoTools from "./pages/admin/SeoTools";
import SiteVerification from "./components/SiteVerification";
import AnalyticsRouteTracker from "./components/AnalyticsRouteTracker";

const wrap = (Component) => (
  <Layout>
    <Component />
  </Layout>
);

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <ScrollToTop />
            <SiteVerification />
            <AnalyticsRouteTracker />
            <Routes>
              {/* Public */}
              <Route path="/" element={wrap(Home)} />
              <Route path="/about" element={wrap(About)} />
              <Route path="/contact" element={wrap(Contact)} />
              <Route path="/faqs" element={wrap(FAQs)} />
              <Route path="/resources" element={wrap(Resources)} />
              <Route path="/accident-types" element={wrap(AccidentTypes)} />
              <Route path="/accident-types/:slug" element={wrap(AccidentTypeDetail)} />
              <Route path="/pennsylvania-cities" element={wrap(PennsylvaniaCities)} />
              <Route path="/pennsylvania-cities/:slug" element={wrap(PennsylvaniaCityDetail)} />
              <Route path="/blog" element={wrap(Blog)} />
              <Route path="/blog/:slug" element={wrap(BlogPostPage)} />
              <Route path="/authors/aaron-bankhurst" element={wrap(AuthorProfile)} />
              <Route path="/editorial-policy" element={wrap(EditorialPolicy)} />
              <Route path="/corrections" element={wrap(CorrectionsPolicy)} />

              {/* Admin */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<LeadsPage />} />
                <Route path="content-strategy" element={<ContentStrategy />} />
                <Route path="calendar" element={<Calendar />} />
                <Route path="blog" element={<BlogManager />} />
                <Route path="cities" element={<CityManager />} />
                <Route path="accident-types" element={<AccidentTypeManager />} />
                <Route path="faqs" element={<FAQManager />} />
                <Route path="testimonials" element={<TestimonialManager />} />
                <Route path="exports" element={<Exports />} />
                <Route path="seo-tools" element={<SeoTools />} />
              </Route>

              <Route path="*" element={wrap(NotFound)} />
            </Routes>
          </BrowserRouter>
        </div>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
